<template>
    <div v-bind:class="app_container_class" id="app-container">
        <div class="container py-5">
            <div class="row">
                <div class="col-8 offset-2 text-center">
                    <div class="card" id="configuration-card">
                        <div class="card-body p-5">
                            <div class="row">
                                <div class="col-8 offset-2 mb-5">
                                    <img src="/assets/kiosk/img/logo-xpayrience-projexmedia.png" alt="xPayrience.com">
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <p v-if="token_found == false">
                                        <a :href="dashboard_url" target="_blank" class="btn btn-lg btn-primary">
                                            {{ this.trans.get('kiosk.configure-this-kiosk') }}
                                        </a>
                                    </p>
                                    <p v-if="token_found == true" class="mb-0">
                                        <router-link :to="{ name: 'home' }">
                                            {{ this.trans.get('kiosk.back-to-kiosk') }}
                                        </router-link>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {isset} from '../../helpers/kiosk-helpers';

export default {
    name: "Configuration",

    computed: {
        dashboard_url: () => {
            if(window.app_env === 'local')
            {
                return 'https://admin3.xpayrience.com' + window.xpayrience_http_port;
            }

            return 'https://admin3.xpayrience.com';
        },
    },

    data() {
        return {
            app_container_class: 'bg-phoenix-no-logo',
            interval: null,
            lang: {
                // open_dashboard: Lang.get('kiosk.open-dashboard'),
                open_dashboard: 'open_dashboard',
            },
            token_found: null,
        }
    },

    methods: {
        init() {
            this.setCheckAccessTokenInterval();
            this.$root.app_is_loaded = true;
        },

        checkAccessToken() {
            if(isset(window.localStorage.getItem('xpayrience_access_token')))
            {
                clearInterval(this.interval);
                this.token_found = true;
                setTimeout(this.redirect_to_home,5000);
            }
            else {
                this.token_found = false;
            }
        },

        redirect_to_home()
        {
            this.$router.push({ name: this.$root.locale + '.home' });
        },

        setCheckAccessTokenInterval()
        {
            this.interval = setInterval(() => {
                this.checkAccessToken();
            }, 1000);
        }
    },

    mounted() {
        this.init();
    }
}
</script>

<style scoped>

</style>
